import { render, staticRenderFns } from "./InvitationItem.vue?vue&type=template&id=5df5c5ae&scoped=true&"
import script from "./InvitationItem.vue?vue&type=script&lang=ts&"
export * from "./InvitationItem.vue?vue&type=script&lang=ts&"
import style0 from "./InvitationItem.vue?vue&type=style&index=0&id=5df5c5ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df5c5ae",
  null
  
)

export default component.exports